//
// Entry point for JS
// ================================================================================


// import { cookies }  from './cookies.js';
// import { dots }     from './dots.js';
// import { numbersIncrease }  from './numbers.js';
import { menu }     from './menu.js';
// import { people }   from './people.js';
// import { popupGallery } from './popup-gallery';
// import { scienhubModal }  from './scienhub-modal.js';
// import { sliders }  from './sliders.js';
// import { sponsors } from './sponsors.js';
import { fitVids } from './fitVids.js';

console.log('loaded - scripts.js');

function autorun(){
    console.log('Website is ready! Theming too!');

    // cookies();
    // dots();
    // numbersIncrease();
    menu();
    // people();
    // popupGallery();
    // scienhubModal();
    // sliders();
    // sponsors();
    fitVids();
};

if (document.addEventListener) document.addEventListener("DOMContentLoaded", autorun, false);
else if (document.attachEvent) document.attachEvent("onreadystatechange", autorun);
else window.onload = autorun;
